<!-- 个人会员组件 -->

<template>
  <div>
    <el-form
        :model="individualMemberForm"
        :rules="individualMemberRules"
        ref="individualMemberFormRef"
        label-width="180px"
        label-position="top"
        class="individualMemberForm"
        :disabled="form_disabled"
    >
      <!--赵 个人会员基本信息 -->
      <div v-show="activeName=='basic'">
        <template v-if="individualMemberForm.audit_status == 4">
          <el-row :gutter="24">
            <div style="width: 100%;position: relative">
            <span
                class="title_text">
              会员信息
            </span>
              <img style="width: 100%" src="@/assets/line.png">
            </div>
          </el-row>
          <el-row :gutter="24">
            <!--                <el-col :span="8">-->
            <!--                  <el-form-item label="姓名" >-->
            <!--                    <el-input disabled v-model="individualMemberForm.full_name" placeholder="  "></el-input>-->
            <!--                  </el-form-item>-->
            <!--                </el-col>-->
            <el-col :span="8">
              <el-form-item label="所属委员会">
                <el-select style="width: 100%" v-model="individualMemberForm.committee_id" placeholder="专委会选择"
                           disabled>
                  <el-option
                      v-for="item in ccompanyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="会员编号">
                <el-input disabled v-model="individualMemberForm.member_code" placeholder="  "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="申请时间">
                <el-input disabled v-model="individualMemberForm.join_time" placeholder="  "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="入会时间">
                <el-input disabled v-model="individualMemberForm.create_time" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="到期时间">
                <el-input disabled v-model="individualMemberForm.due_time" placeholder=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="委员会职务">
                <el-input disabled v-model="individualMemberForm.committee_position" placeholder="  "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="协会职务">
                <el-input disabled v-model="individualMemberForm.association_position" placeholder="  "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
            </el-col>
          </el-row>
        </template>

        <el-row :gutter="24" v-for="(items, indexs) in SheetData.basic" :key="indexs">
          <div v-if="items.title && items.display" style="width: 100%;position: relative">
            <span
                class="title_text"
            >{{
                items.title
              }}</span>
            <img style="width: 100%" src="@/assets/line.png">
          </div>
          <el-col v-else :xl="item.xl?item.xl:8" :lg="item.lg?item.lg:8" v-for="(item, index) in items" :key="index">
            <!--                          还是不够完善。。。。。。-->
            <el-form-item v-if="item.display" :label="item.label"
                          :prop="(item.prop==='job_title'||item.prop==='job_title_pic')&&(individualMemberForm.committee_id!=5&&individualMemberForm.committee_id!=6)?'':(item.prop==='work_experience'|| item.prop==='position_pic' )&&(individualMemberForm.committee_id==11)?'':item.prop">
              <!--              <div v-if="item.prop=='mandate_file'"></div>-->
              <el-input
                  class="selitem"
                  v-if="item.assembly_type === 'input'"
                  v-model="individualMemberForm[item.prop]"
                  :placeholder="'请输入'+ item.label"
                  :type="item.type"
                  :disabled="item.disabled"
              ></el-input>

              <el-select
                  class="selitem"
                  v-if="item.assembly_type === 'el_option'"
                  v-model="individualMemberForm[item.prop]"
                  :placeholder="'请选择'+ item.label"
                  clearable
                  :multiple="item.multiple"
                  :disabled="item.disabled"
                  @change="(e)=>{return el_option_change(e, item.prop)}"
              >
                <el-option
                    v-for="every in item.options"
                    :key="every.value"
                    :label="every.name"
                    :value="every.value"
                >
                </el-option>
              </el-select>

              <el-cascader
                  class="selitem"
                  v-if="item.assembly_type === 'el_cascader'"
                  v-model="individualMemberForm[item.prop]"
                  :options="item.options"
                  clearable
                  :disabled="item.disabled"
              >
              </el-cascader>
              <el-input
                  class="selitem"
                  show-word-limit
                  rows="4"
                  v-if="item.assembly_type === 'input_textarea'"
                  v-model="individualMemberForm[item.prop]"
                  :placeholder="'请输入'+ item.prompt"
                  :type="item.type"
                  :disabled="item.disabled"
              ></el-input>
              <template v-if="item.assembly_type === 'el_checkbox'">
                <el-checkbox-group
                    v-model="individualMemberForm[item.prop]"
                >
                  <el-checkbox v-for="(check_item,check_index) in item.options" :label="check_item.name"
                               :key="check_index"
                               @change="formCheckedChange"
                  >
                  </el-checkbox>
                </el-checkbox-group>
                <el-input v-if="Collaborated_before_show && item.prop=='designers_type'" v-model="Collaborated_before"
                          placeholder="请输入合作过的品牌和企业" style="margin: 12px 0;width: 51%"></el-input>
                <el-input v-if="Other_notes_show && item.prop=='designers_type'" v-model="Other_notes"
                          placeholder="选择其他请注明" style="width: 51%"></el-input>
                <!--专业方向-->
                <el-input v-if="major_field_show && item.prop=='major_field'" v-model="major_field_Other_notes"
                          placeholder="选择其他请注明" style="width: 51%"></el-input>
                <!-- 希望学习的课程方向-->
                <el-input v-if="course_direction_show && item.prop=='course_direction'"
                          v-model="course_direction_Other_notes"
                          placeholder="选择其他请注明" style="width: 51%"></el-input>
              </template>
              <!--              <template  v-if="item.assembly_type === 'el_radio'">-->
              <!--                <el-radio-group  v-model="individualMemberForm[item.prop]">-->
              <!--                  <el-radio v-for="(item,index) in item.options" :label="item.name" :key="index">{{item.name}}</el-radio>-->
              <!--                </el-radio-group>-->
              <!--              </template>-->
              <template v-if="item.assembly_type === 'image_up'">
                <div v-if="individualMemberForm[item.prop]&&individualMemberForm[item.prop].length>0">
                  <div class="image" v-if="individualMemberForm[item.prop].slice(-3) == 'jpg'||individualMemberForm[item.prop].slice(-3) == 'png'||individualMemberForm[item.prop].slice(-3) == 'gif'||individualMemberForm[item.prop].slice(-4) == 'jpeg'||individualMemberForm[item.prop].slice(-4) == 'webp'">
                    <el-image :src="$imgUrl+individualMemberForm[item.prop]"></el-image>
                    <div class="upload-span">
                  <span class="upload-icon" @click.stop="handlePreview(individualMemberForm[item.prop])"><i
                      class="el-icon-zoom-in"></i></span>
                      <span v-if="!form_disabled" class="upload-icon" @click.stop="handleRemove(item.prop)" style="margin-left: 20px"><i
                          class="el-icon-delete"></i></span>
                    </div>
                  </div>
                  <div class="image" v-else>
                    <div>
                      <div style="display: flex;align-items: center">
                        <div class="el-icon-paperclip" style="margin-right: 5px;cursor: pointer"></div>
                        <div style="margin-right: 10px;cursor: pointer"
                             @click="view_file(individualMemberForm[item.prop])">{{ item.label }}
                        </div>
                        <div v-if="!form_disabled" class="el-icon-close" style="cursor: pointer" @click.stop="handleRemove(item.prop)"></div>

                      </div>
                    </div>
                  </div>


                </div>


                <div v-if="!individualMemberForm[item.prop]">
                  <el-upload
                      :action="$Url"
                      list-type="picture-card"
                      :headers="headers"
                      :multiple="false"
                      :on-success="(response, file, fileList) => {return handleSuccess(response, file, fileList, item.prop)}"
                      :on-error="handleError"
                      :show-file-list="false">
                    <i class="el-icon-plus">
                      <div class="uploadtxt">{{ item.prompt }}</div>
                    </i>
                  </el-upload>
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
            v-if="SheetData.basic[SheetData.basic.length-1].title=='品牌' && SheetData.basic[SheetData.basic.length-1].display"
            class="tableBox">
          <el-col :xl="24" :lg="24">
            <!--            <div class="btnBox">-->
            <!--              <div class="searchBtnBox">-->
            <!--                <div class="main-title">品牌列表</div>-->
            <!--                <button class="btn search-btn" @click="changeBrand('add','')">创建品牌</button>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="invitate-wrap">
              <!-- 列表 -->
              <div class="invitation-table">
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    border
                    :cell-style="{textAlign: 'center'}"
                    :header-cell-style="{background:'#EDF1F7',color: '#333', textAlign: 'center'}"
                >
                  <el-table-column
                      prop="ownership_type"
                      label="所属类型">
                    <template v-slot="scope">
                      {{ scope.row.type == 1 ? '个人会员' : '单位会员' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="brand_name"
                      label="品牌名称">
                  </el-table-column>
                  <!--                  <el-table-column-->
                  <!--                      prop="brand_type"-->
                  <!--                      label="品牌类别">-->
                  <!--                  </el-table-column>-->
                  <!--                  <el-table-column-->
                  <!--                      prop="registration_time"-->
                  <!--                      label="注册时间">-->
                  <!--                  </el-table-column>-->
                  <el-table-column
                      prop="registration_address"
                      label="注册地">
                  </el-table-column>
                  <el-table-column
                      prop="SKU"
                      label="年SKU数">
                  </el-table-column>
                  <el-table-column
                      prop="category"
                      label="品类"
                      width="250px"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="honors"
                      label="奖项及荣誉"
                      width=""
                  >
                  </el-table-column>

                  <el-table-column
                      fixed="right"
                      label="操作"
                      width="120">
                    <template v-slot="scope">
                      <el-button
                          @click.native.prevent="changeBrand('edit',scope.row)"
                          type="text"
                          size="small">
                        编辑
                      </el-button>
                      <el-button
                          @click.native.prevent="delRow(scope.row)"
                          type="text"
                          style="color: red"
                          size="small">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
            </div>
            <div style="text-align: center;margin: 20px">
              <button class="btn search-btn" @click.prevent="changeBrand('add','')" style="font-size: 18px">添加品牌
              </button>
              <!--              <div class="btn_prompt" >如您就职或创立品牌，请点此填写品牌信息</div>-->
            </div>
            <!--            <div class="paginationbox">-->
            <!--              <el-pagination-->
            <!--                  @size-change="handleSizeChange"-->
            <!--                  @current-change="handleCurrentChange"-->
            <!--                  :current-page="page_no"-->
            <!--                  :page-sizes="[10, 20, 30, 50]"-->
            <!--                  :page-size="page_size"-->
            <!--                  layout="total, sizes, prev, pager, next, jumper"-->
            <!--                  :total="total">-->
            <!--              </el-pagination>-->
            <!--            </div>-->
          </el-col>
        </el-row>
      </div>
      <!-- 赵 品牌新增/编辑 -->

    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog :title="brandTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="700px">
      <el-form :model="brandForm" :rules="brandFormRules" ref="brandFormRef" label-position="top">
        <el-form-item label="品牌名称" prop="brand_name">
          <el-input v-model="brandForm.brand_name" placeholder="  "></el-input>
        </el-form-item>
        <el-form-item label="品牌官网">
          <el-input v-model="brandForm.website" placeholder="请输入品牌官网"></el-input>
        </el-form-item>
        <el-form-item label="品牌归属" prop="brand_type">
          <el-select v-model="brandForm.brand_type" placeholder="请选择品牌归属" class="selitem">
            <el-option
                v-for="every in inbrand_type_options"
                :key="every.value"
                :label="every.name"
                :value="every.value"
            >
            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="注册时间" prop="registration_time">
          <el-date-picker type="date" placeholder="选择注册时间" value-format="yyyy-MM-dd"
                          v-model="brandForm.registration_time"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="注册地" prop="registration_address">
          <el-input v-model="brandForm.registration_address" placeholder="请输入注册地"></el-input>
        </el-form-item>
        <el-form-item label="商标注册证/代理授权" prop="logo" style="width:100%">
          <div class="image" v-if="brandForm.trademark&&brandForm.trademark.length>0">
            <el-image :src="$imgUrl+brandForm.trademark"></el-image>
            <div class="upload-span">
              <span class="upload-icon" @click.stop="handlePreview(brandForm.trademark)"><i
                  class="el-icon-zoom-in"></i></span>
              <span class="upload-icon" @click.stop="trademarkRemove()" style="margin-left: 20px"><i
                  class="el-icon-delete"></i></span>
            </div>
          </div>

          <div v-else>
            <el-upload
                :action="$Url"
                list-type="picture-card"
                :headers="headers"
                :multiple="false"
                :on-success="trademarkSuccess"
                :on-error="trademarkError"
                :show-file-list="false">
              <i class="el-icon-plus">
                <div class="uploadtxt">pdf文件或图片均可，大小在500kb以内</div>
              </i>
            </el-upload
            >
          </div>
        </el-form-item>
        <el-form-item label="品类" prop="category">
          <template v-if=" individualMemberForm.committee_id != 3">
            <div>服装</div>
            <el-checkbox-group v-model="checkCategory">
              <el-checkbox v-for="(item,index) in member_clothing" :label="item.name" :key="index"
                           @change="handleCheckedChange"
              >
              </el-checkbox>
            </el-checkbox-group>
            <el-input v-if="Clothing_Other" v-model="Clothing_Other_text" placeholder="请输入其他服装品类"></el-input>
          </template>
          <template>
            <div>配饰</div>
            <el-checkbox-group v-model="checkCategory">
              <el-checkbox v-for="(item,index) in member_ornament" :label="item.name" :key="index"
                           @change="handleCheckedChange"
              >
              </el-checkbox>
            </el-checkbox-group>
            <el-input v-if="Accessories_Other" v-model="Accessories_Other_text"
                      placeholder="请输入其他配饰品类"></el-input>
          </template>
        </el-form-item>
        <el-form-item label="线下分布" prop="offline_store">
          <el-input
              v-model="brandForm.offline_store"
              type="textarea" rows="4" clearable
              placeholder="自营店数量城市及商业名称：（如北京skp、北京合生汇）加盟/代理店数量：城市及商业名称：入驻买手店/集合店/showroom数量：城市及名称：无"
              class="selitem"
          ></el-input>
        </el-form-item>
        <el-form-item label="入驻电商平台" prop="online_store">
          <!--          <el-select v-model="brandForm.online_store" placeholder="请选择入驻电商平台" multiple class="selitem">-->
          <!--            <el-option-->
          <!--                v-for="every in member_platform"-->
          <!--                :key="every.value"-->
          <!--                :label="every.name"-->
          <!--                :value="every.value"-->
          <!--            >-->
          <!--            </el-option>-->

          <!--          </el-select>-->
          <el-checkbox-group v-model="checkOnline_store">
            <el-checkbox v-for="(item,index) in member_platform" :label="item.name" :key="index"
                         @change="handleCheckedChange"
            >{{ item.value }}
            </el-checkbox>
          </el-checkbox-group>
          <el-input v-if="E_commerce_Other" v-model="E_commerce_Other_text"
                    placeholder="请输入其他入驻电商平台"></el-input>
        </el-form-item>
        <el-form-item label="其他销售渠道" prop="">
          <el-input v-model="brandForm.sales_channel" placeholder="请输入其他销售渠道"></el-input>
        </el-form-item>
        <el-form-item label="年SKU数" prop="SKU">
          <el-input v-model="brandForm.SKU" placeholder="请输入年SKU数"></el-input>
        </el-form-item>
        <el-form-item label="产品价位" prop="product_price">
          <el-input v-model="brandForm.product_price" placeholder="请输入产品价位"></el-input>
        </el-form-item>
        <el-form-item label="奖项及荣誉" prop="honors">
          <el-input
              v-model="brandForm.honors"
              type="textarea" rows="4" clearable
              placeholder="如：中国驰名商标 2024年度时尚品牌奖"
              class="selitem"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="btn" @click="dialogFormVisible = false">取 消</button>
        <button class="btn next_btn next" @click="brandFormsave">确 定</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  MemberBrand_add,
  MemberBrand_delete,
  MemberBrand_detail,
  MemberBrand_edit,
  MemberBrandLists,
  MemberLevel_lists,
} from "@/api/api";
import de from "element-ui/src/locale/lang/de";
import router from "@/router";

export default {
  props: ["activeName", 'SheetData', 'form_data'],
  data() {
    return {
      Collaborated_before: '',
      Other_notes: '',
      major_field_Other_notes: '',
      course_direction_Other_notes: '',
      Collaborated_before_show: false,
      Other_notes_show: false,
      form_disabled: false,
      major_field_show: false,
      course_direction_show: false,
      ccompanyList: JSON.parse(localStorage.getItem('ccompanyList')),
      SheetData_ancillary: [],
      headers: {
        token: localStorage.getItem("token")
      },
      tableData: [],
      checkAll: false,
      checkCategory: [],
      checkOnline_store: [],
      form_checkbox_store: [],
      Clothing_Other: false,
      Accessories_Other: false,
      E_commerce_Other: false,
      Clothing_Other_text: '',
      Accessories_Other_text: '',
      E_commerce_Other_text: '',

      isIndeterminate: false,
      locationdata: JSON.parse(localStorage.getItem("locationdata")),

      dialogVisible: false,
      dialogImageUrl: "",
      imageUrl: "",
      file: "",

      individualMemberForm: {//个人会员信息表单
        id: "",
        full_name: "",//姓名
        gender: "",//性别
        nationality: "",// 民族
        mobile: "",//手机号
        wechat: "",//微信号
        email: "",//邮箱
        IDCard: "",//身份证号
        IDCard_facade_pic: "",//身份证正面
        IDCard_back_pic: "",//身份证反面
        education_level: "",//最高学历
        graduate_school: "",//最高学历毕业院校
        majors: "",//最高学历专业
        diploma: '',//毕业证或学位证
        job_title: "",//职称
        job_title_pic: '',//职称证明文件
        company: "",//工作单位
        position: "",//职务
        position_pic: '',//任职证明文件
        // country:"",//国家
        // province:"",//省份
        city: [],//城市
        address: "",//通信地址
        provincesMunicipalities: [],//省市区组合
        resume: "",//个人简历
        educational_experience: "",//教育经历
        training_experience: "",//培训经历
        work_experience: "",//工作经历
        personal_achievements: "",//获奖经历及专业成就
        personal_achievements_pic: '',//获奖证书及成就证明文件
        media_account: "",//自媒体账号
        weibo: "",//微博粉丝数
        tiktok: "",//抖音粉丝数
        red_book: "",//小红书粉丝数
        other_platforms: "",//其他平台粉丝数
        organization: "",//已参加的组织
        personal_works: "",//个人作品
        major_field: '',//专业方向
        course_direction: '',//希望学习的课程方向
        is_brand: 1,//是否自有工作室/品牌
        company_size: "",//公司规模
        operating_condition: "",//经营状况
        designers_type: "",//属于哪种设计师
        domestic_activities: "",//
        foreign_activities: "",//
        activity_pic: "",//活动相关证明资料
        progress: 0,//进度
        // handwritten_sign:"",//手写签名
      },
      individualMemberRules: {//个人会员表单验证
        full_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: ['blur', 'change']},
        ],
        job_title: [
          {required: true, message: '请输入职称', trigger: ['blur', 'change']},
        ],
        // job_title_pic: [
        //   {required: true, message: '请上传职称证明文件', trigger: ['blur', 'change']},
        // ],
        nationality: [
          {required: true, message: '请选择民族', trigger: ['blur', 'change']},
        ],
        mobile: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号码格式不正确",
          trigger: "blur",
        },],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
        ],
        company: [
          {required: true, message: '请输入工作单位', trigger: 'blur'},
        ],
        city: [
          {required: true, message: '请选择省市区', trigger: ['blur', 'change']},
        ],
        designers_type: [
          {required: true, message: '请选择属于哪种设计师', trigger: ['blur', 'change']},
        ],
        magazine_reception: [
          {required: true, message: '请选择接收杂志方式', trigger: ['blur', 'change']},
        ],
        address: [
          {required: true, message: '请输入通信地址', trigger: 'blur'},
        ],
        educational_experience: [
          {required: true, message: '请输入教育经历', trigger: 'blur'},
        ],
        work_experience: [
          {required: true, message: '请输入工作经历', trigger: 'blur'},
        ],
        IDCard: [
          {required: true, message: '请输入身份证号', trigger: 'blur'},
        ],
        head_photo: [
          {required: true, message: '请上传身份证正面', trigger: 'change'},
        ],
        IDCard_facade_pic: [
          {required: true, message: '请上传身份证正面', trigger: 'change'},
        ],
        IDCard_back_pic: [
          {required: true, message: '请上传身份证反面', trigger: 'change'},
        ],
        education_level: [
          {required: true, message: '请输入最高学历', trigger: 'blur'},
        ],
        graduate_school: [
          {required: true, message: '最高学历毕业院校', trigger: 'blur'},
        ],
        majors: [
          {required: true, message: '最高学历专业', trigger: 'blur'},
        ],
        diploma: [
          {required: true, message: '请上传最高学历证明', trigger: 'change'},
        ],
        position_pic: [
          {required: true, message: '请上传任职证明文件', trigger: 'change'},
        ],
        company_size: [
          {required: true, message: '请输入公司规模', trigger: ['blur', 'change']},
        ],
        operating_condition: [
          {required: true, message: '请输入经营状况', trigger: ['blur', 'change']},
        ],
        major_field: [
          {required: true, message: '请选择专业方向', trigger: ['blur', 'change']},
        ],
        course_direction: [
          {required: true, message: '请选择希望学习的课程方向', trigger: ['blur', 'change']},
        ],
        is_brand: [
          {required: true, message: '请选择是否自有工作室/品牌', trigger: ['blur', 'change']},
        ],
        position: [
          {required: true, message: '请输入职务', trigger: ['blur', 'change']},
        ],
        personal_achievements: [
          {required: true, message: '请输入获奖经历及专业成就', trigger: ['blur', 'change']},
        ],
        personal_works: [
          {required: true, message: '请上传个人作品', trigger: 'change'},
        ],
      },
      MemberLevelList: [],
      dialogFormVisible: false,//品牌弹窗
      committee_text_show: false,//富文本弹窗
      brandTitle: "",//品牌弹窗名称
      brandForm: {//品牌表单数据
        id: "",//品牌id
        ownership: "",//所属类型 1:个人会员，2:单位会员
        user_long_id: "",//所关联的用户长ID
        brand_name: "",//品牌名称
        website: "",//品牌官网
        brand_type: "",//品牌类别
        registration_time: "",//注册时间
        registration_address: "",//注册地
        trademark: [],//商标注册证或代理授权
        category: "",//品类
        offline_store: "自营店数量：\n分布城市及商业名称：（如北京skp、北京合生汇）\n\n加盟/代理店数量：\n分布城市及商业名称：\n\n入驻买手店/集合店/showroom数量：\n分布城市及店名称：\n\n无实体店请写：无",//线上分布/线上店铺
        online_store: "",//入驻电商平台
        SKU: "",//年sku数
        product_price: "",//产品及价位
        honors: "",//奖项及荣誉
      },
      brandFormRules: {//品牌表单验证
        brand_name: [
          {required: true, message: '请输入品牌名称', trigger: ['blur', 'change']},
        ],
        brand_type: [
          {required: true, message: '请选择品牌归属', trigger: ['blur', 'change']},
        ],
        registration_time: [
          {required: true, message: '请选择注册时间', trigger: ['blur', 'change']},
        ],
        registration_address: [
          {required: true, message: '请输入注册地', trigger: ['blur', 'change']},
        ],
        category: [
          {required: true, message: '请选择品类', trigger: ['blur', 'change']},
        ],

        offline_store: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
        ],
        online_store: [
          {required: true, message: '请选择入驻电商平台', trigger: ['blur', 'change']},
        ],
        SKU: [
          {required: true, message: '请输入年SKU数', trigger: ['blur', 'change']},
        ],
        product_price: [
          {required: true, message: '请输入产品价位', trigger: ['blur', 'change']},
        ],
        honors: [
          {required: true, message: '请输入', trigger: ['blur', 'change']},
        ],
      },
      inbrand_type_options: JSON.parse(localStorage.getItem('dictdata')).belong_brand,
      member_clothing: JSON.parse(localStorage.getItem('dictdata')).member_clothing,
      member_ornament: JSON.parse(localStorage.getItem('dictdata')).member_ornament,
      category_options: JSON.parse(localStorage.getItem('dictdata')).member_brand_category,
      member_platform: JSON.parse(localStorage.getItem('dictdata')).member_platform,
      total: 1,
      page_no: 1,
      page_size: 10,
      result: [],
      // 提交不可修改字段数组
      dis_field: [
        'full_name',
        'IDCard',
      ],
      // 学术独有的是否为品牌，需要填写字段
      is_brandArr: [
        'company_size',
        'company_',
        'activity',
        'operating_condition',
        'company_size',
        'domestic_activities',
        'foreign_activities',
        'activity_pic',
        'designers_type',
        'brand'
      ],

      backups: [],
    }

  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs['individualMemberFormRef'].clearValidate()
    })
    this.backups = JSON.parse(JSON.stringify(this.SheetData))

    // this.SheetData_ancillary=JSON.parse(JSON.stringify( this.SheetData.ancillary))
    this.individualMemberForm = JSON.parse(JSON.stringify(this.form_data))
    this.form_disabled = this.individualMemberForm.audit_status != 0
    this.init()
    this.disa()
    this.el_option_change(this.individualMemberForm.is_brand, 'is_brand')
    // this.find_el_checkbox(this.SheetData.basic)

    this.getMemberBrandLists()
    this.getMemberLevel_lists()
    // 个人会员不能修改的字段：姓名、所属委员会、会员编号、申请时间、入会时间、到期时间、协会奖项、协会职务、委员会职务
    // 不在会员端显示字段：备注。  不能修改指的是提交后不能修改，如果有驳回，驳回后可修改
    // let aa = JSON.parse(localStorage.getItem('dictdata')).member_clothing
    // let bb = JSON.parse(localStorage.getItem('dictdata')).member_ornament
    //
    // this.category_options


  },

  watch: {
    activeName(val) {
      if (val == 'brand') {
        this.getMemberBrandLists()
      }
    },
    form_data(val) {
      this.individualMemberForm = JSON.parse(JSON.stringify(val))
      this.init()
      this.form_disabled = this.individualMemberForm.audit_status != 0
      this.disa()
    }
  },
  methods: {
    init() {
      this.individualMemberForm.designers_type = this.individualMemberForm.designers_type ? this.individualMemberForm.designers_type.split(",") : []
      console.log(this.individualMemberForm.designers_type, this.$refs['individualMemberRef'])
      this.individualMemberForm.designers_type.forEach((item, index) => {
        if (item.includes('为品牌或企业提供设计服务')) {
          this.Collaborated_before = item.substring(item.lastIndexOf("&") + 1)
          this.individualMemberForm.designers_type[index] = item.substring(0, item.lastIndexOf("&"))
        }
      })
      this.individualMemberForm.designers_type.forEach((item, index) => {
        if (item.includes('其他')) {
          this.Other_notes = item.substring(item.lastIndexOf("&") + 1)
          this.individualMemberForm.designers_type[index] = item.substring(0, item.lastIndexOf("&"))
        }
      })

      this.Collaborated_before_show = this.individualMemberForm.designers_type.some(item => {
        return item == '为品牌或企业提供设计服务'
      })
      this.Other_notes_show = this.individualMemberForm.designers_type.some(item => {
        return item == '其他'
      })
      this.individualMemberForm.major_field = this.individualMemberForm.major_field ? this.individualMemberForm.major_field.split(",") : []
      console.log(this.individualMemberForm.major_field)
      this.individualMemberForm.major_field.forEach((item, index) => {
        if (item.includes('其他')) {
          this.major_field_Other_notes = item.substring(item.lastIndexOf("&") + 1)
          this.individualMemberForm.major_field[index] = item.substring(0, item.lastIndexOf("&"))
        }
      })
      this.major_field_show = this.individualMemberForm.major_field.some(item => {
        return item == '其他'
      })
      this.individualMemberForm.course_direction = this.individualMemberForm.course_direction ? this.individualMemberForm.course_direction.split(",") : []
      this.individualMemberForm.course_direction.forEach((item, index) => {
        if (item.includes('其他')) {
          this.course_direction_Other_notes = item.substring(item.lastIndexOf("&") + 1)
          this.individualMemberForm.course_direction[index] = item.substring(0, item.lastIndexOf("&"))
        }
      })
      this.course_direction_show = this.individualMemberForm.course_direction.some(item => {
        return item == '其他'
      })
    },
    disa() {
      if (this.individualMemberForm.audit_status != 0 && this.individualMemberForm.audit_status != 5) {
        this.SheetData.basic.forEach(item => {
          if (!item.title) {
            item.forEach(items => {
              let qq = this.dis_field.some(dis => {
                return dis == items.prop
              })
              if (qq) {
                items.disabled = true
              }
            })
          }
        })
      }
    },
    change_form_disabled() {
      this.form_disabled = !this.form_disabled
    },
    getMemberBrandLists() {

      let data = this.$qs.stringify({
        page_no: this.page_no,
        page_size: this.page_size,
        type: this.individualMemberForm.type,
      });
      MemberBrandLists(data).then((res) => {
        if (res.code == 1) {

          this.tableData = res.data.lists;
          console.log(this.page_size, 'this.page_size')
          this.total = res.data.count
        }
      })
          .catch((err) => {
            console.log(err);
          });

    },

    el_option_change(e, prop) {
      // this.result = []
      // this.toOneArray(this.SheetData.basic)
      // let aa = this.result.filter((suit) => {
      //   return suit.prop == prop
      // })
      if (prop == 'is_brand' && this.individualMemberForm.committee_id == 5) {
        this.findTrueValue(this.SheetData.basic)
        console.log(this.SheetData.basic)

        // for(let i=0;i<this.SheetData.basic.length;i++){
        //
        // }

        // this.SheetData.basic.forEach(item=>{
        //   if(item.prop!='is_brand'&& item.prop!='designers_type')
        //   item.display=e==1
        // })
      }
    },
    // 解决数组嵌套
    toOneArray(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i])) {
          this.toOneArray(arr[i])
        } else {
          this.result.push(arr[i])
        }
      }
      return this.result
    },
    findTrueValue(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].prop) {
          if (this.is_brandArr.indexOf(arr[i].prop) != -1) {
            arr[i].display = this.individualMemberForm.is_brand == 1
          } else if (Array.isArray(arr[i])) {
            this.findTrueValue(arr[i]);
          }
        } else {
          this.findTrueValue(arr[i]);
        }

      }
    },

    handleCheckedChange(value) {
      this.brandForm.category = this.checkCategory.toString()
      this.brandForm.online_store = this.checkOnline_store.toString()
      this.checkOnline_store = this.checkOnline_store.some(item => {
        return item == '无'
      }) ? ['无'] : this.checkOnline_store
      this.Clothing_Other = this.checkCategory.some(item => {
        return item == '其他服装品类'
      })
      this.Accessories_Other = this.checkCategory.some(item => {
        return item == '其他配饰品类'
      })
      this.E_commerce_Other = this.checkOnline_store.some(item => {
        return item == '其他'
      })
    },
    formCheckedChange(value) {
      this.Collaborated_before_show = this.individualMemberForm.designers_type.some(item => {
        return item == '为品牌或企业提供设计服务'
      })
      this.Other_notes_show = this.individualMemberForm.designers_type.some(item => {
        return item == '其他'
      })
      this.major_field_show = this.individualMemberForm.major_field.some(item => {
        return item == '其他'
      })
      this.course_direction_show = this.individualMemberForm.course_direction.some(item => {
        return item == '其他'
      })
    },

    //zhao 上传成功
    handleSuccess(response, file, fileList, field) {
      if (response.code == 1) {
        this.$message.success(response.msg)
        this.individualMemberForm[field] = response.data.uri
      } else {
        this.$message.error(response.msg)
      }

    },
    // zhao 上传失败
    handleError(err, file, fileList) {
      this.$message.error(err.msg);
    },
    //zhao  删除图片
    handleRemove(field) {
      console.log(this.individualMemberForm[field])

      this.individualMemberForm[field] = ""
    },
    //赵 预览图片 通用
    handlePreview(file) {
      this.dialogImageUrl = this.$imgUrl + file;
      this.dialogVisible = true;
    },
    handleReset() {
      this.$refs.esign.reset();
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        console.log(res, "res")
      }).catch(err => {
        if (err == 'Warning: Not Signned!') {
          this.$message.error("请在空白处手写签名")
        }
        console.log(err); // 画布没有签字时会执行这里 'Not Signned'
      });
    },
    // 新增/编辑品牌
    changeBrand(type, row) {
      this.checkCategory = []
      this.checkOnline_store = []
      this.Clothing_Other = false
      this.Accessories_Other = false
      this.E_commerce_Other = false
      this.brandForm = {//品牌表单数据
        id: "",//品牌id
        ownership: "",//所属类型 1:个人会员，2:单位会员
        user_long_id: "",//所关联的用户长ID
        brand_name: "",//品牌名称
        website: "",//品牌官网
        brand_type: "",//品牌类别
        registration_time: "",//注册时间
        registration_address: "",//注册地
        trademark: [],//商标注册证或代理授权
        category: "",//品类
        offline_store: "自营店数量：\n分布城市及商业名称：（如北京skp、北京合生汇）\n\n加盟/代理店数量：\n分布城市及商业名称：\n\n入驻买手店/集合店/showroom数量：\n分布城市及店名称：\n\n无实体店请写：无",//线上分布/线上店铺
        online_store: "",//入驻电商平台
        SKU: "",//年sku数
        product_price: "",//产品及价位
        honors: "",//奖项及荣誉
      };
      if (type == 'add') {
        this.brandTitle = '新建品牌';
      } else {
        this.MemberBrandDetail(row)
        this.brandTitle = '编辑品牌';
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['brandFormRef'].clearValidate()
      })
    },
    MemberBrandDetail(row) {
      let data = this.$qs.stringify({id: row.id});
      MemberBrand_detail(data).then((res) => {
        if (res.code == 1) {
          this.checkCategory = res.data.category.split(',')
          this.checkOnline_store = res.data.online_store.split(',')

          this.checkCategory.forEach((item, index) => {
            if (item.includes('其他服装品类')) {
              this.Clothing_Other_text = item.substring(item.lastIndexOf("&") + 1)
              this.checkCategory[index] = item.substring(0, item.lastIndexOf("&"))
            }
          })
          this.checkCategory.forEach((item, index) => {
            if (item.includes('其他配饰品类')) {
              this.Accessories_Other_text = item.substring(item.lastIndexOf("&") + 1)
              this.checkCategory[index] = item.substring(0, item.lastIndexOf("&"))
            }
          })
          this.checkOnline_store.forEach((item, index) => {
            if (item.includes('其他')) {
              this.E_commerce_Other_text = item.substring(item.lastIndexOf("&") + 1)
              this.checkOnline_store[index] = item.substring(0, item.lastIndexOf("&"))
            }
          })
          this.Clothing_Other = this.checkCategory.some(item => {
            return item == '其他服装品类'
          })
          this.Accessories_Other = this.checkCategory.some(item => {
            return item == '其他配饰品类'
          })
          this.E_commerce_Other = this.checkOnline_store.some(item => {
            return item == '其他'
          })

          this.brandForm = res.data

        }
      })
          .catch((err) => {
            console.log(err);
          });

    },
    brandFormsave() {
      this.$refs['brandFormRef'].validate((valid) => {
        if (valid) {
          if (this.Clothing_Other) {
            this.checkCategory.forEach((item, index) => {
              if (item == '其他服装品类') {
                this.checkCategory[index] = item + '&' + this.Clothing_Other_text
              }
            })
          }
          if (this.Accessories_Other) {
            this.checkCategory.forEach((item, index) => {
              if (item == '其他配饰品类') {
                this.checkCategory[index] = item + '&' + this.Accessories_Other_text
              }
            })
          }
          if (this.E_commerce_Other) {
            this.checkOnline_store.forEach((item, index) => {
              if (item == '其他') {
                this.checkOnline_store[index] = item + '&' + this.E_commerce_Other_text
              }
            })
          }
          console.log(this.checkOnline_store);
          this.brandForm.category = this.checkCategory.join(',')
          this.brandForm.online_store = this.checkOnline_store.join(',')
          let data = JSON.parse(JSON.stringify(this.brandForm))
          data.type = this.individualMemberForm.type

          if (this.brandForm.id != '') {
            MemberBrand_edit(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.dialogFormVisible = false;
                this.getMemberBrandLists()

              }
            })
                .catch((err) => {
                  console.log(err);
                });
          } else {
            MemberBrand_add(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.dialogFormVisible = false;
                this.getMemberBrandLists()

              }
            })
                .catch((err) => {
                  console.log(err);
                });
          }

        } else {
          this.$message.warning('请将表格填写完整')
        }
      })


    },

    //zhao 上传成功
    trademarkSuccess(response, file, fileList, field) {
      if (response.code == 1) {
        this.$message.success(response.msg)
        this.brandForm.trademark = response.data.uri
      } else {
        this.$message.error(response.msg)
      }

    },
    // zhao 上传失败
    trademarkError(err, file, fileList) {
      this.$message.error(err.msg);
    },
    //zhao  删除图片
    trademarkRemove(field) {
      this.brandForm.trademark = ""
    },
    view_file(file) {
      window.open(file, '_blank');
    },
    del_file(file) {
      window.open(file, '_blank');

    },
// 删除品牌
    delRow(row) {
      this.$confirm("确定要删除此条品牌数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            let data = {
              id: row.id
            }
            MemberBrand_delete(data).then((res) => {
              if (res.code == 1) {
                this.$message.success(res.msg);
                this.getMemberBrandLists()
              }
            }).catch((err) => {
              console.log(err);
            });
          })
    },
    // 分页相关
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page_no = val;
      this.getMemberBrandLists();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    // updateData(data) {
    //   let form = JSON.parse(JSON.stringify(data))
    //
    //   this.individualMemberForm = form
    //   this.el_option_change(this.individualMemberForm.is_brand,'is_brand')
    //   this.getMemberBrandLists()
    // },
    validateForm() {
      let obj = {
        flag: false,
        firstInvalidField: ''
      }
      this.$refs['individualMemberFormRef'].validate((valid, object) => {
        obj.flag = valid
        obj.firstInvalidField = Object.keys(object)[0];


      })
      return obj
    },
    // 获取会员等级
    getMemberLevel_lists() {
      let id = this.individualMemberForm.committee_id;
      let data = this.$qs.stringify({committee_id: id});
      return MemberLevel_lists(data).then((res) => {
        if (res.code == 1) {
          this.MemberLevelList = res.data.lists;
        } else {
          this.$message.warning(res.msg);
        }
      }).catch((error) => {
        // 处理可能出现的错误
        console.error('Error fetching member level lists:', error);
        throw error;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-form-item__content{
  display: block !important;
}
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }


  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

.individualMemberForm {
  margin-top: 30px;

  .selitem {
    width: 100%;
  }

  .title_text {
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;
    left: 5px;
    color: #FFFFFF;
    font-size: 0.1rem
  }
}

.individualMemberForm .el-row {
  display: flex;
  justify-content: center;
}

.tips {
  color: red;
  font-size: 12px;
}

.main-title {
  font-size: 18px;
  font-weight: 600;
  color: #565B7D;
  line-height: 37px;
}

.esignBtn {
  margin-top: 10px;
}

/deep/ .el-form-item {
  margin-bottom: 15px !important;
}

.searchBtnBox {
  display: flex;
}

.btn_prompt {
  margin-top: 10px;
  color: red;
  font-weight: 300;
}
</style>